// extracted by mini-css-extract-plugin
export default {"loader":"Loader__loader-wBdw","loaderText":"Loader__loaderText-TLZo"};